import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "max-height d-flex center flex-d-c"
}
const _hoisted_2 = { key: 1 }
const _hoisted_3 = { class: "center" }
const _hoisted_4 = {
  class: "center py-1",
  style: {"position":"relative"}
}
const _hoisted_5 = {
  class: "center-y",
  style: {"position":"absolute","top":"10px","right":"80px"}
}
const _hoisted_6 = {
  class: "center-y",
  style: {"position":"absolute","top":"8px","left":"80px"}
}
const _hoisted_7 = { class: "fs-smaller mt-1 grey1-grey3-color" }
const _hoisted_8 = { class: "fs-smaller mt-1 grey1-grey3-color" }

import { IonButton, IonCol, IonGrid, IonIcon, IonImg, IonRow, IonText, IonToggle, modalController } from "@ionic/vue";
import { computed, onBeforeUnmount, onMounted, ref, watch } from "vue";
import { route } from "@/router";
import { t } from "@/plugins/vue-i18n";
import { alertController, isPlatform } from "@ionic/core";

import ButtonBase from "@/components/button/ButtonBase.vue";
import CustomHeader from "@/components/basePageElements/CustomHeader.vue";
import ModalControllerBase from "@/components/modal/modalControllerModals/ModalControllerBase.vue";
import ScanProduct from "@/components/modal/ScanProduct.vue";
import ScanDetailsSliding from "@/components/various/ScanDetailsSliding.vue";

import { useListStore } from "@/stores/lists";
import { useSupplierStore } from "@/stores/suppliers";
import { usePersistentStore } from "@/stores/persistent";
import { useUserStore } from "@/stores/user";

import { useLoader } from "@/composables/useLoader";

import { popAlertConfirm, popAlertOk } from "@/functions/alert";
import { isDark } from "@/functions/theme";

import { CatalogItem } from "@/types/supplier";

import { chevronBack } from "ionicons/icons";
import { ION_VARIANT } from "@/types/enum/ionicEnum";
import { PERMISSION_KEY } from "@/types/user";

// ─── NEW: @capacitor/barcode-scanner ────────────────────────────────────────────
// This plugin has a single method: CapacitorBarcodeScanner.scanBarcode(options)
// It opens a native scanner activity/view and returns a Promise with the result.
// No listeners, no background hiding, no permissions API — all handled natively.
import {
    CapacitorBarcodeScanner,
    CapacitorBarcodeScannerTypeHintALLOption,
    CapacitorBarcodeScannerCameraDirection,
    CapacitorBarcodeScannerScanOrientation,
    type CapacitorBarcodeScannerScanResult,
} from '@capacitor/barcode-scanner';
// ─────────────────────────────────────────────────────────────────────────────────

/**
 * Starts a barcode scan using the native scanner activity.
 * @capacitor/barcode-scanner opens a full-screen native scanner — no WebView
 * transparency or CSS hacks needed. The promise resolves when the user scans
 * a barcode or cancels.
 */
interface ScanModalProps {
    supplierId: string;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'ScanModal',
  props: {
    supplierId: {}
  },
  setup(__props: any) {

const startScan = async () => {
    try {
        const result: CapacitorBarcodeScannerScanResult = await CapacitorBarcodeScanner.scanBarcode({
            hint: CapacitorBarcodeScannerTypeHintALLOption.ALL,
            cameraDirection: CapacitorBarcodeScannerCameraDirection.BACK,
            scanOrientation: CapacitorBarcodeScannerScanOrientation.PORTRAIT,
            scanInstructions: t('messages.scanDesiredProducts'),
            scanButton: false,
            scanText: '',
            android: {
                scanningLibrary: 'mlkit' as any, // or 'zxing'
            },
        });

        console.log("SCAN VALUE", result.ScanResult);

        // result.ScanResult is an empty string when the user cancels
        if (result.ScanResult) {
            await addSupplierCatalogItemByEan(result.ScanResult);
        }
    } catch (error) {
        console.error('Barcode scan error:', error);
    }
};

const props = __props

const persistentStore = usePersistentStore()
const {
    scanList,
    listItems,
    addListItem,
    addItemToCart,
    patchListItem,
    getListItems,
    clearScanList,
    addScanItem,
    changeItemQuantity,
} = useListStore()
const listStore = useListStore()
const supplierStore = useSupplierStore()
const userStore = useUserStore()
const { showLoading, hideLoading } = useLoader()

let scanResult = ''

const currentScanList = computed<Array<CatalogItem>>(() => scanList[props.supplierId] ?? [])
const amount = computed<{ items: number, positions: number }>(() => {
    return currentScanList.value.reduce((value: {
        items: number,
        positions: number,
        ids: Array<string>
    }, list: CatalogItem) => {
        if (value.ids.includes(list.id)) {
            value.items += list.quantity ?? 1
        } else {
            value.ids.push(list.id)
            value.items += list.quantity ?? 1
            value.positions += 1
        }

        return value
    }, { items: 0, positions: 0, ids: [] })
})
const locationId = computed<string>(() => String(route.value.params.locationId))
const isDisableAddCart = computed<boolean>(() => !amount.value.positions)
const allItems = computed(() => {
    return listItems[props.supplierId]?.data?.length
        ? scanList[props.supplierId].reduce((items: {
            newItems: Array<CatalogItem>,
            otherItems: Array<CatalogItem>
        }, item: CatalogItem) => {
            const listItem = listItems[props.supplierId].data.find((list) => list.supplierItemId === item.id)
            if (listItem?.id) {
                item.listItemId = listItem.id
                items.otherItems.push(item)
            } else items.newItems.push(item)

            return items
        }, { newItems: [], otherItems: [] })
        : { newItems: scanList[props.supplierId], otherItems: [] }
})

const handleScanToggle = (ev: Event) => {
    console.log("EVENT", (ev.target as HTMLIonToggleElement)?.checked)
    // true = device scanner, false = camera scanner
}

const addToList = async (): Promise<void> => {
    alertController.dismiss()
    await showLoading()

    for (const catalogItem of allItems.value.newItems) {
        await addItemToCart(locationId.value, catalogItem.id, catalogItem.quantity ?? 1)
    }

    for (const catalogItem of allItems.value.otherItems) {
        // patchCartItem(locationId: string, itemId: string, quantity: number)
    }

    listStore.getShoppingCart(locationId.value)
    hideLoading()
    modalController.dismiss()
    clearScanList(props.supplierId)
}

const checkOverrideScanList = (): void => {
    popAlertConfirm({
        message: t(`messages.${allItems.value.otherItems.length ? 'updateScanItems' : 'addScanItems'}`),
        cancelText: t('button.cancel'),
        handler: {
            ok: addToList
        }
    })
}

const openScanModalProduct = async (catalogItem: CatalogItem, isModal = false): Promise<void> => {
    const currentItem = currentScanList.value.find((item) => item.id === catalogItem.id) ?? catalogItem

    if (currentItem?.quantity !== 1 && !isModal) return

    const modal = await modalController.create({
        id: 'EAN_' + String(currentItem.id),
        component: ScanProduct,
        cssClass: 'scrollable-at-max-breakpoint height-auto',
        componentProps: {
            catalogItem: currentItem,
            supplierId: props.supplierId
        },
        breakpoints: [0, 1],
        initialBreakpoint: 1
    })

    await modal.present()
}

const addSupplierCatalogItemByEan = async (scannerResponse: string): Promise<boolean> => {

    const response = await supplierStore.getSupplierCatalogItemByEan(locationId.value, props.supplierId, scannerResponse)
    const alert = await alertController.getTop()
    if (alert) await alertController.dismiss()
    if (!response) {
        await hideLoading()
        await popAlertOk({
            message: t('error.scannedProductNotAvailable'),
            id: '404',
            handler: () => {
                // Re-open scanner after dismissing the "not found" alert
                startScan()
            }
        })
        return false
    }

    response.quantity = (response.amountStep) ? response.amountStep : 1;
    addScanItem(props.supplierId, response)

    const topModal = await modalController.getTop()
    if (topModal?.id.startsWith('EAN_')) {
        if (topModal.id !== 'EAN_' + String(response.id)) {
            await modalController.dismiss({ id: topModal.id })
            await openScanModalProduct(response, true)
        }
    } else {
        await openScanModalProduct(response, true)
    }

    await hideLoading()
    return true
}

let timeout: number | null = null
const acceptInput = () => {
    const eanCode = scanResult
    scanResult = ''
    if (eanCode) addSupplierCatalogItemByEan(eanCode)
}

const checkScannerInput = (input: KeyboardEvent) => {
    if (input.key === 'Unidentified') return
    const inputKey = input.key.toString()
    if (!listStore.isScanHardware || (isNaN(parseInt(inputKey)) && inputKey != 'Enter' && inputKey.length === 1) || (input.target as HTMLElement)?.localName === "input") return

    //  if not enter and is number add to scanResult
    if (inputKey != 'Enter' && !isNaN(parseInt(inputKey))) {
        scanResult += inputKey
    } else {
        // maybe its a longer string with not only numbers
        for (let i = 0; i < inputKey.length; i++) {
            // check every char if number -> add to scanResult
            if (!isNaN(parseInt(inputKey[i]))) scanResult += inputKey
        }
    }

    if (inputKey == 'Enter' || scanResult.length > 12) {
        if (timeout) clearTimeout(timeout)
        timeout = null
        acceptInput()
    } else if (scanResult.length === 8) {
        timeout = setTimeout(() => {
            acceptInput()
        }, 300) as unknown as number
    }
}

const listener = (input: KeyboardEvent) => checkScannerInput(input)

const backListener = (ev: Event) => {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    //@ts-ignore
    ev.detail.register(100, async (processNextHandler) => {
        processNextHandler()
    })
}

//prevent closing modal when using hardware back button
document.addEventListener('ionBackButton', backListener)

onBeforeUnmount(() => {
    document.removeEventListener('ionBackButton', backListener)
    window.removeEventListener('keyup', listener, true)
    resizeObserver?.disconnect()
    resizeObserver = null;
})

const scanItemsEl = ref<HTMLElement | null>(null)
const showButton = ref(false)
let resizeObserver: ResizeObserver | null = null

function calculateHeight () {
    const contentHeight = document.querySelector('.scanner-modal')?.querySelector('ion-content')?.scrollHeight || 0;
    showButton.value = (scanItemsEl.value?.scrollHeight || 0) + 50 > contentHeight
}

onMounted(() => {
    resizeObserver = new ResizeObserver(calculateHeight)

    if (scanItemsEl.value) {
        resizeObserver.observe(scanItemsEl.value)
    }

    watch(scanItemsEl, (el, oldEl) => {
        if (oldEl && resizeObserver) {
            resizeObserver.unobserve(oldEl) // stop observing previous element
        }
        if (el && resizeObserver) {
            resizeObserver.observe(el) // observe new element
        }
    }, { immediate: true })

    calculateHeight()
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(ModalControllerBase, {
    contentClass: "light-light-background",
    footer: ""
  }, {
    header: _withCtx(() => [
      _createVNode(CustomHeader, {
        class: "barcode-scanner-visible",
        "back-button": "",
        title: _ctx.$t('titleRoute.scanner')
      }, {
        start: _withCtx(() => [
          _createVNode(_unref(IonButton), {
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(modalController).dismiss())),
            class: "purple-light-color"
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(IonIcon), { icon: _unref(chevronBack) }, null, 8, ["icon"]),
              _createTextVNode(" " + _toDisplayString(_ctx.$t('button.back')), 1)
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["title"])
    ]),
    footer: _withCtx(() => [
      _createVNode(_unref(IonGrid), { class: "light-light-background purple-light-color barcode-scanner-visible" }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createVNode(_unref(IonText), { class: "fs-smaller pr-2 purple-purple-color" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('label.scanner')), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_unref(IonImg), {
                  class: "scanner-icon",
                  src: "/assets/icon/barcode.svg"
                })
              ]),
              _createVNode(_unref(IonToggle), {
                onIonChange: handleScanToggle,
                modelValue: _unref(listStore).isScanHardware,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_unref(listStore).isScanHardware) = $event)),
                class: "accordion-toggle px-2",
                mode: "ios",
                color: _unref(ION_VARIANT).CORAL
              }, null, 8, ["modelValue", "color"]),
              _createElementVNode("div", _hoisted_6, [
                _createVNode(_unref(IonImg), {
                  class: "camera-icon",
                  src: "/assets/icon/camera-outline.svg"
                }),
                _createVNode(_unref(IonText), { class: "fs-smaller pl-1 purple-purple-color" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('label.camera')), 1)
                  ]),
                  _: 1
                })
              ])
            ])
          ])
        ]),
        _: 1
      }),
      _createVNode(_unref(IonGrid), {
        class: _normalizeClass(["purple-light-color p-0 barcode-scanner-visible", {
                'light-purple-background': _unref(isDark)() && currentScanList.value.length,
                'grey4-grey4-background': !_unref(isDark)() && currentScanList.value.length,
                'light-light-background': !currentScanList.value.length
            }]),
        style: _normalizeStyle((_unref(isPlatform)('ios')) ? 'padding-bottom: 34px' : '')
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(IonRow), null, {
            default: _withCtx(() => [
              _createVNode(_unref(IonCol), {
                size: "5",
                class: "center-y pl-2",
                style: {"min-height":"30px"}
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", null, [
                    _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.$t('messages.cart.amountItems', { amount: amount.value.items })), 1),
                    _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.$t('messages.cart.amount', { amount: amount.value.positions })), 1)
                  ])
                ]),
                _: 1
              }),
              (!_unref(persistentStore).offlineMode)
                ? (_openBlock(), _createBlock(_unref(IonCol), {
                    key: 0,
                    offset: "1",
                    size: "6",
                    class: "ion-justify-content-end d-flex ion-align-items-center pr-2"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(ButtonBase, {
                        disabled: isDisableAddCart.value || currentScanList.value.length < 1,
                        class: "wrap-button fw-b m-0",
                        onClick: checkOverrideScanList
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$t('button.updateCart')), 1)
                        ]),
                        _: 1
                      }, 8, ["disabled"])
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["class", "style"])
    ]),
    default: _withCtx(() => [
      (!currentScanList.value.length)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createVNode(_unref(IonImg), {
              src: "/assets/icon/barcode-scan.svg",
              class: "mb-3"
            }),
            _createVNode(_unref(IonText), {
              class: "fw-b fs-18 text-center purple-purple-color",
              style: {"width":"260px"}
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('messages.scanDesiredProducts')), 1)
              ]),
              _: 1
            }),
            _createVNode(_unref(IonRow), null, {
              default: _withCtx(() => [
                _createVNode(_unref(IonCol), { class: "center" }, {
                  default: _withCtx(() => [
                    (!_unref(listStore).isScanHardware)
                      ? (_openBlock(), _createBlock(ButtonBase, {
                          key: 0,
                          onClick: _cache[1] || (_cache[1] = ($event: any) => (startScan()))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$t('button.openCameraScanner')), 1)
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_2, [
            (showButton.value && !_unref(listStore).isScanHardware)
              ? (_openBlock(), _createBlock(_unref(IonRow), {
                  key: 0,
                  style: {"border-bottom":"2px solid var(--ion-color-grey4)"}
                }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(IonCol), { class: "center" }, {
                      default: _withCtx(() => [
                        _createVNode(ButtonBase, {
                          onClick: _cache[2] || (_cache[2] = ($event: any) => (startScan()))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$t('button.openCameraScanner')), 1)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            _createElementVNode("div", {
              ref_key: "scanItemsEl",
              ref: scanItemsEl
            }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList([...currentScanList.value].reverse(), (catalogItem) => {
                return (_openBlock(), _createBlock(ScanDetailsSliding, {
                  key: catalogItem.id,
                  style: {"width":"100%"},
                  edit: _unref(userStore).permission[_unref(PERMISSION_KEY).CART_UPDATE] || _unref(userStore).permission[_unref(PERMISSION_KEY).CART_DELETE],
                  entry: catalogItem,
                  listId: __props.supplierId,
                  onAmount: ($event: any) => (_unref(changeItemQuantity)(__props.supplierId, catalogItem.id, $event)),
                  onClick: ($event: any) => (openScanModalProduct(catalogItem, true))
                }, null, 8, ["edit", "entry", "listId", "onAmount", "onClick"]))
              }), 128))
            ], 512),
            _createVNode(_unref(IonRow), { class: "py-3" }, {
              default: _withCtx(() => [
                _createVNode(_unref(IonCol), { class: "center" }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(IonImg), {
                      src: "/assets/icon/barcode-scan.svg",
                      style: {"width":"40px"},
                      class: "mr-2"
                    }),
                    _createVNode(_unref(IonText), {
                      style: {"max-width":"150px","line-height":"20px"},
                      class: "purple-purple-color fs-smaller fw-b"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t('messages.scanToAddMoreProducts')), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_unref(IonRow), null, {
              default: _withCtx(() => [
                _createVNode(_unref(IonCol), { class: "center" }, {
                  default: _withCtx(() => [
                    (!_unref(listStore).isScanHardware)
                      ? (_openBlock(), _createBlock(ButtonBase, {
                          key: 0,
                          onClick: _cache[3] || (_cache[3] = ($event: any) => (startScan()))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$t('button.openCameraScanner')), 1)
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]))
    ]),
    _: 1
  }))
}
}

})